import "core-js/modules/es6.object.set-prototype-of";
import "core-js/modules/es6.object.create";
import "core-js/modules/es6.object.define-property";
import React from 'react';

function addScript(src, id) {
  var script = document.createElement('script');
  script.src = src;
  script.id = id;
  document.body.appendChild(script);
}

function removeScript(id) {
  var script = document.getElementById(id);

  if (id) {
    script.parentElement.removeChild(script);
  }
}

var classCallCheck = function classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
};

var createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();

var inherits = function inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
};

var possibleConstructorReturn = function possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
};
/**
 * Embeds Hyvor Talk thread on a web page
 */


var Embed = function (_React$Component) {
  inherits(Embed, _React$Component);

  function Embed() {
    classCallCheck(this, Embed);
    return possibleConstructorReturn(this, (Embed.__proto__ || Object.getPrototypeOf(Embed)).apply(this, arguments));
  }

  createClass(Embed, [{
    key: 'setVariables',
    value: function setVariables() {
      window.HYVOR_TALK_WEBSITE = this.props.websiteId;
      window.HYVOR_TALK_CONFIG = {
        url: this.props.url || false,
        id: this.props.id || false,
        loadMode: this.props.loadMode || 'default'
      };
    }
  }, {
    key: 'addScript',
    value: function addScript$$1() {
      if (document.getElementById('ht-embed-script')) {
        removeScript('ht-embed-script');
      }

      addScript('//talk.hyvor.com/web-api/embed', 'ht-embed-script');
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.setVariables();
      this.addScript();
    }
  }, {
    key: 'render',
    value: function render() {
      return React.createElement('div', {
        id: 'hyvor-talk-view'
      });
    }
  }]);
  return Embed;
}(React.Component);

var CommentCount = function (_React$Component) {
  inherits(CommentCount, _React$Component);

  function CommentCount() {
    classCallCheck(this, CommentCount);
    return possibleConstructorReturn(this, (CommentCount.__proto__ || Object.getPrototypeOf(CommentCount)).apply(this, arguments));
  }

  createClass(CommentCount, [{
    key: 'setVariables',
    value: function setVariables() {
      if (this.props.websiteId) {
        window.HYVOR_TALK_WEBSITE = this.props.websiteId;
      }
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.setVariables();
      var scriptId = 'ht-comment-count-script';

      if (document.getElementById(scriptId)) {
        removeScript(scriptId);
      }

      addScript('//talk.hyvor.com/web-api/count/', scriptId);
    }
  }, {
    key: 'render',
    value: function render() {
      return React.createElement('span', {
        'data-talk-id': this.props.id,
        mode: this.props.mode || 'default'
      });
    }
  }]);
  return CommentCount;
}(React.Component);

var HyvorTalk = {
  Embed: Embed,
  CommentCount: CommentCount
};
export default HyvorTalk;